import { v4 as uuid } from "uuid";
/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    id:1,
    title: "Feather Wall Macrame",
    price: "1000",
    offprice:700,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577922/ProjectImages/productmacrame-1_efqyvz.png",
    rating:4.5,
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    title: "Wall hanging ",
    price: "700",
    offprice:600,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577922/ProjectImages/productmacrame-2_hwimal.png",
    rating:4,
    categoryName: "Macrame",
  },
  { 
    _id: uuid(),
    title: "shelf Wall hanging",
    price: "700",
    offprice:600,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577272/ProjectImages/productmacrame-3_lajtdg.png",
    rating:4.1,
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    title: "Multicolor hanging",
    price: "700",
    offprice:600,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577271/ProjectImages/productmacrame-6_jqxato.png",
    rating:3,
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    title: "Circular macrame",
    price: "700",
    offprice:500,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577271/ProjectImages/productmacrame-9_anrjcx.png",
    rating:3.5,
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    title: "Macrame plant hangers",
    price: "700",
    offprice:500,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647578830/ProjectImages/productmacrame-10_h6psvi.png",
    rating:3.5,
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    title: "Triangle macrame",
    price: "700",
    offprice:500,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577271/ProjectImages/productmacrame-4_ugxxhs.png",
   rating:3.5,
    categoryName: "Macrame",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "700",
    offprice:500,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577228/ProjectImages/productdream-5_uljdgg.png",
    rating:3.5,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "700",
    offprice:500,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577229/ProjectImages/productdream-7_oedsbj.png",
    rating:3.5,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577228/ProjectImages/productdream-2_kkxuuv.png",
    rating:4.5,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577228/ProjectImages/productdream-6_lmnne5.png",
    rating:4.5,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577228/ProjectImages/productdream-3_n9w2sc.png",
    rating:4.5,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577228/ProjectImages/productdream-1_viithx.png",
    rating:4,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "dreamcatcher",
    price: "700",
    offprice:300,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577228/ProjectImages/productdream-4_fmlg7y.png",
    rating:4.5,
    categoryName: "DreamCatcher",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577288/ProjectImages/productplants-3_aylif8.png",
    rating:3.8,
    categoryName: "Plants",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577289/ProjectImages/productplants-7_p9gxrp.png",
    rating:3.9,
    categoryName: "Plants",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "600",
    offprice:300,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577289/ProjectImages/productplants-1_xhhbde.png",
    rating:4.1,
    categoryName: "Plants",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "500",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577289/ProjectImages/productplants-6_bwkb9u.png",
    rating:3.8,
    categoryName: "Plants",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "400",
    offprice:200,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577290/ProjectImages/productplants-2_pcdtil.png",
    rating:1,
    categoryName: "Plants",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "1200",
    offprice:600,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577290/ProjectImages/productplants-4_meupib.png",
    rating:4.8,
    categoryName: "Plants",
  },
  {
    _id: uuid(),
    title: "plants",
    price: "500",
    offprice:300,
    image:"https://res.cloudinary.com/dgomw715r/image/upload/v1647577288/ProjectImages/productplants-5_ecvens.png",
    rating:5,
    categoryName: "Plants",
  },
];
